import React from 'react'

import {useAppDispatch} from '../../hooks/redux'
import {closeModal} from '../../redux/features/modal'

import Button from '../../../../commons/src/components/button'
import Headline from '../../../../commons/src/components/headline'
import Modal from '../../../../commons/src/components/modal'

type Props = {
  title: string
  content: React.ReactNode
  onConfirm: () => void
  confirmButtonLabel?: string
}

const SimpleConfirmModal = ({title, content, onConfirm, confirmButtonLabel = 'Confirm'}: Props) => {
  const dispatch = useAppDispatch()

  return (
    <Modal
      headline={<Headline label={title} size="l" warning />}
      onClose={() => dispatch(closeModal())}
      buttons={
        <>
          <Button hierarchy="ghost" onClick={() => dispatch(closeModal())}>
            Cancel
          </Button>
          <Button onClick={onConfirm}>{confirmButtonLabel}</Button>
        </>
      }
    >
      {content}
    </Modal>
  )
}

export default SimpleConfirmModal
